<template>
    <v-layout row justify-end>

        <v-dialog v-model="pauseDialog" persistent max-width="480">
            <template v-slot:activator="{ on }">
                <v-btn
                    v-on="on"
                    color="secondary">
                    Mettre en pause
                </v-btn>
            </template>
            <v-card>
                <v-form ref="pauseTreatmentForm" lazy-validation>
                    <v-card-title class="headline">Mettre en pause le traitement</v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <h4>Etes-vous sûr de vouloir mettre en pause ce traitement ?</h4>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" @click="pauseDialog = false">Annuler</v-btn>
                        <v-btn color="primary" @click="pauseTreatment">Oui, mettre en pause</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" persistent max-width="480">
            <template v-slot:activator="{ on }">
                <v-btn
                    v-on="on"
                    color="primary">
                    Fermer le traitement
                </v-btn>
            </template>
            <v-card>
                <v-form ref="closeTreatmentForm" lazy-validation>
                    <v-card-title class="headline">Fermer le traitement</v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <h4>Etes-vous sûr de vouloir fermer ce traitement ?</h4>
                                    <v-select v-model="reason" :items="reasons" label="Raison" required></v-select>
                                    <v-textarea v-model="remarks" label="Remarques" v-if="reason === 'OTHER'" required></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" @click="dialog = false">Annuler</v-btn>
                        <v-btn color="primary" @click="save">Oui, fermer</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import {mapActions, mapState} from 'vuex'
    import {getTranslationString} from "../../../helper";

    export default {
        name: "TreatmentCloseForm",
        data () {
            return {
                dialog: false,
                pauseDialog: false,
                remarks: '',
                reasons: [
                    {text: this.getText('DEATH'), value: 'DEATH'},
                    {text: this.getText('PATIENT_WITHDRAWAL'), value: 'PATIENT_WITHDRAWAL'},
                    {text: this.getText('DOCTOR_WITHDRAWAL'), value: 'DOCTOR_WITHDRAWAL'},
                    {text: this.getText('OTHER'), value: 'OTHER'},
                ],
                reason: '',
            }
        },
        computed: {
            ...mapState('medical_cases', {
                selectedMedicalCase: state => state.selectedMedicalCase,
            }),
            ...mapState('treatments', {
                selectedTreatment: state => state.selectedTreatment,
            }),
        },
        methods: {
            getText(key) {
                return getTranslationString(key)
            },
            save() {
                this.dialog = false;
                if (this.selectedTreatment && this.selectedMedicalCase) {
                    this.closeTreatment({remarks: this.remarks, reason: this.reason}).then(response => {
                        this.$router.push({name: 'patient.viewMedicalCase', params: { medical_case_id: this.selectedMedicalCase.id }});
                    }).catch(reason => {
                        //Stay here..
                    })
                }
            },
            pauseTreatment() {
                this.pauseDialog = false;
                if (this.selectedTreatment && this.selectedMedicalCase) {
                    this.closeTreatment({reason: 'PAUSED', remarks: null}).then(response => {
                        this.$router.push({name: 'patient.viewMedicalCase', params: { medical_case_id: this.selectedMedicalCase.id }});
                    }).catch(reason => {
                        //Stay here..
                    })
                }
            },
            ...mapActions('treatments', [
                'closeTreatment'
            ]),
        }
    }
</script>
